import { createContext } from 'react'

const twofactorContext = createContext()

export default twofactorContext
